import { usePuzzle } from '../../context/PuzzleContext'
import { EndGameModal, useShareHandler } from '@shared'

export default function PuzzleEndModal ({ onPlayAgain, onGoHome }) {
  const { difficulty, gameSnapshot } = usePuzzle()
  const { handleShare, isSharing, shareError, shareVisible } = useShareHandler({
    getShareBlockReason: () =>
      !gameSnapshot ? 'shared.share.noSnapshot' : null,
    buildShareData: () => {
      // Invariant: gameSnapshot exists (validated by getShareBlockReason)
      return {
        type: 'puzzle',
        difficulty,
        imageSrc: gameSnapshot.imageSrc
      }
    },
    logPrefix: '[PuzzleEndModal]'
  })

  return (
    <EndGameModal
      onPlayAgain={onPlayAgain}
      onGoHome={onGoHome}
      onShare={handleShare}
      shareVisible={shareVisible}
      isSharing={isSharing}
      shareError={shareError}
    />
  )
}
